import React from "react";
import { Stack } from "react-bootstrap";
import "./B2BAgents3.css";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import { SlArrowLeft, SlArrowRight } from "react-icons/sl";
import { map } from "lodash";

export const B2BAgents3 = () => {
  const data = [
    {
      SupplierId: "0",
      ImagePath:
        "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/supplier/hotel.webp",
      Title: "HOTELS",
    },
    {
      SupplierId: "1",
      ImagePath:
        "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/supplier/activities.webp",
      Title: "ACTIVITIES",
    },
    {
      SupplierId: "2",
      ImagePath:
        "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/supplier/transfer.webp",
      Title: "TRANSFERS",
    },
    {
      SupplierId: "3",
      ImagePath:
        "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/supplier/group%20departure.webp",
      Title: "GROUP DEPARTURES",
    },
    {
      SupplierId: "4",
      ImagePath:
        "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/supplier/mice%20support.webp",
      Title: "MICE SUPPORT (via AGENTS)",
    },
    {
      SupplierId: "5",
      ImagePath:
        "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/supplier/local%20experience.webp",
      Title: "LOCAL EXPERIENCES",
    },
  ];

  const settings = {
    infinite: true,
    speed: 1000,
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: true,
    arrows: true,
    prevArrow: (
      <button className="slick-prev">
        <img
          className="agents3-slider-arrow"
          src="/assets/blue-icon1.svg"
          alt="Prev"
        />
      </button>
    ),
    nextArrow: (
      <button className="slick-next">
        <img
          className="agents3-slider-arrow agents3-slider-right-arrow"
          src="/assets/blue-icon2.svg"
          alt="Next"
        />
      </button>
    ),
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },

      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 430,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <div className="b2b-suppliers standard-padding pt-0">
      <h1 className="heading mb-4 b2b-suppliers-heading">Trusted Suppliers We Work With</h1>

      <div className="b2b-suppliers-slider-wrapper">
        <Swiper
          modules={[Navigation, Pagination, Autoplay]}
          spaceBetween={12}
          slidesPerView={3}
          loop={true}
          autoplay={{
            delay: 2500,
            disableOnInteraction: false,
          }}
          navigation={{
            nextEl: ".agents3-next",
            prevEl: ".agents3-prev",
          }}
          pagination={{
            clickable: true,
          }}
          breakpoints={{
            0: {
              slidesPerView: 1,
            },
            600: {
              slidesPerView: 2,
            },
            1024: {
              slidesPerView: 3,
            },
          }}
          className="b2b-suppliers-slider"
        >
          {map(data, (d) => (
            <SwiperSlide key={d.SupplierId}>
              <div
                className="b2b-suppliers-card"
                style={{
                  backgroundImage: `url(${d.ImagePath})`,
                }}
              >
                <Stack direction="horizontal" gap={4}>
                  <h5>{d.Title}</h5>
                </Stack>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        {/* CUSTOM ARROWS */}
        <div className="agents3-nav agents3-prev">
          <SlArrowLeft />
        </div>

        <div className="agents3-nav agents3-next">
          <SlArrowRight />
        </div>
      </div>
    </div>
  );
};
